import React from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { MenuItem } from "@shared/interfaces";
import { AccessControl } from "@shared/components/AccessControl";

import "./index.scss";

interface SidebarItemProps {
  item: MenuItem;
}

const SidebarItem = (props: SidebarItemProps) => {
  const { item } = props;

  const { path, name, permission, Icon } = item;

  return (
    <AccessControl permission={permission}>
      <div className="sidebar-item">
        <NavLink to={path}>
          <>
            {Icon ? <Icon /> : <div className="active-line" />}
            <div className={classnames("item-name")}>{name}</div>
          </>
        </NavLink>
      </div>
    </AccessControl>
  );
};

export default SidebarItem;
